<template>
    <TopNav></TopNav>
		<h1>Luhn Algorithm Validator</h1>
		<fieldset>
      <legend>Luhn Algorithm Validator</legend>
      <label for="inputNumberId">Number:</label> <input type="number" v-model="inputNumber" id="inputNumberId" size="40" min="0" step="1">
      <br><br>
      Validation: <span v-bind:class="classObject()">{{ status() }}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'
import luhn from 'luhn'

export default {
  name: "Luhn",
  data() {
    return {
        inputNumber: ""
    }
  },
  components: {
    TopNav
  },
  methods: {
    status: function () {
      if (luhn.validate(this.inputNumber) && this.inputNumber > 0) {
        return "Valid";
      } else if (luhn.validate(this.inputNumber) === false && this.inputNumber > 0) {
        return "Not Valid";
      } else {
        return "";
      }
    },
    classObject: function () {
      if (luhn.validate(this.inputNumber)) {
        return {
          "positive": true
        }
      } else {
        return {
          "negative": true
        }
      }
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 50px;
}

footer section a {
  margin: 20px;
}

label {
  display: inline-block;
  width: 110px;
}

.positive {
  color: #008A00
}

.negative {
  color: #EB0000
}
</style>
